import EventDatatable from "./event_datatable_controller";

// Connects to data-controller="home-past-event-datatable"
export default class extends EventDatatable {

  get pageLength() {
    return 4;
  }
}
